module.exports = "<ion-app>\n  <app-sidemenu></app-sidemenu>\n  <ion-router-outlet id=\"content1\"></ion-router-outlet>\n</ion-app>\n"